export function createOverlappingSubscription(subscribeFn) {
  let currentHandle = null;

  function subscribe(name, args, { onError, onReady } = {}) {
    if (!name) {
      stop();
      return null;
    }

    const previousHandle = currentHandle;
    const nextHandle = subscribeFn(name, ...args, {
      onError(error) {
        onError?.(error);
      },
      onReady() {
        if (previousHandle && previousHandle !== nextHandle) {
          previousHandle.stop();
        }
        onReady?.();
      },
    });
    currentHandle = nextHandle;
    return nextHandle;
  }

  function stop() {
    currentHandle?.stop?.();
    currentHandle = null;
  }

  function ready() {
    return Boolean(currentHandle?.ready?.());
  }

  return { subscribe, stop, ready };
}
